// import React, { useState, useEffect } from "react";
// import { Input, FormFeedback, Tooltip } from "reactstrap";

// const AmountInput = ({
//     label = "Amount",
//     placeholder = "Enter amount",
//     required = false, 
//     layout = "below", 
//     value = "", 
//     name = "amount",
//     id = "amountInput", 
//     min = 1, 
//     max = 100000,
//     onChange = () => {}, 
//     onBlur = () => {}, 
//     validateTrigger = false,
//     requiredErrorMessage = "Amount is required.", 
//     rangeErrorMessage = `Amount must be between {min} and {max}.`, 
//     numericErrorMessage = "Only numeric values are allowed.",
//     showHelp = false, 
//     helpText = "Please enter an amount.",
// }) => {
//     const [inputValue, setInputValue] = useState(value);
//     const [errors, setErrors] = useState({}); 
//     const [tooltipOpen, setTooltipOpen] = useState(false);

//     // Sync inputValue with prop value whenever value prop changes
//     useEffect(() => {
//         setInputValue(value);
//     }, [value]);

//     useEffect(() => {
//         if (validateTrigger) {
//             validateAmount(inputValue);
//         }
//     }, [validateTrigger]);

//     const validateAmount = (value) => {
//         const newErrors = {};
//         const isNumeric = /^[0-9]*$/; 

//         if (required && !value) {
//             newErrors.required = requiredErrorMessage;
//         } else if (value && !isNumeric.test(value)) {
//             newErrors.numeric = numericErrorMessage;
//         } else if (value && (value < min || value > max)) {
//             newErrors.range = rangeErrorMessage
//                 .replace("{min}", min)
//                 .replace("{max}", max);
//         }

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleInputChange = (e) => {
//         const newValue = e.target.value;
//         setInputValue(newValue); 
//         validateAmount(newValue); 
//         onChange(e); 
//     };

//     const handleInputBlur = (e) => {
//         validateAmount(e.target.value);
//     };

//     return (
//         <div className={layout === "inline" ? "d-flex align-items-center" : ""}>
//             <label htmlFor={id} className="d-flex" style={{ width: layout === "inline" ? "20%" : "100%" }}>
//                 {label}
//                 {required && <span className="text-danger ml-1">*</span>} 
//                 {showHelp && (
//                     <span id="helpTooltip" className="px-2">
//                         <i
//                             className="ri-question-line"
//                             style={{ cursor: 'pointer', fontSize: '16px' }}
//                         ></i>
//                     </span>
//                 )}
//             </label>
//             {showHelp && (
//                 <Tooltip
//                     placement="right"
//                     isOpen={tooltipOpen}
//                     target="helpTooltip"
//                     toggle={() => setTooltipOpen(!tooltipOpen)}
//                 >
//                     {helpText}
//                 </Tooltip>
//             )}
//             <div className="w-100">
//                 <Input
//                     type="text"
//                     name={name} 
//                     id={id}
//                     placeholder={placeholder}
//                     value={inputValue}
//                     onChange={handleInputChange}
//                     onBlur={handleInputBlur} 
//                     invalid={
//                         (required && !!errors.required) || 
//                         (!!errors.range || !!errors.numeric)
//                     }
//                 />
//                 {errors.required && (
//                     <FormFeedback type="invalid">
//                         {errors.required}
//                     </FormFeedback>
//                 )}
//                 {errors.range && (
//                     <FormFeedback type="invalid">
//                         {errors.range}
//                     </FormFeedback>
//                 )}
//                 {errors.numeric && (
//                     <FormFeedback type="invalid">
//                         {errors.numeric}
//                     </FormFeedback>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default AmountInput;






import React, { useState, useEffect } from "react";
import { Input, FormFeedback, Tooltip } from "reactstrap";

const AmountInput = ({
    label = "Amount",
    placeholder = "Enter amount",
    required = false,
    layout = "below",
    value = "",
    name = "amount",
    id = "amountInput",
    min = 1,
    max = 100000,
    onChange = () => {},
    onBlur = () => {},
    validateTrigger = false,
    requiredErrorMessage = "Amount is required.",
    rangeErrorMessage = `Amount must be between {min} and {max}.`,
    numericErrorMessage = "Only numeric values are allowed.",
    showHelp = false,
    helpText = "Please enter an amount.",
    disabled = false,
  }) => {
    const [errors, setErrors] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState(false);
  
    useEffect(() => {
      if (validateTrigger) {
        validateAmount(value);
      }
    }, [validateTrigger]);
  
    const validateAmount = (value) => {
      const newErrors = {};
      const isNumeric =  /^\d*\.?\d*$/;
  
      if (required && !value) {
        newErrors.required = requiredErrorMessage;
      } else if (value && !isNumeric.test(value)) {
        newErrors.numeric = numericErrorMessage;
      } else if (value && (value < min || value > max)) {
        newErrors.range = rangeErrorMessage.replace("{min}", min).replace("{max}", max);
      }
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };
  
    const handleInputChange = (e) => {
      const newValue = e.target.value;
      validateAmount(newValue);
      onChange(name, newValue); // Pass the updated value directly to Formik’s setFieldValue
    };
  
    const handleInputBlur = (e) => {
      validateAmount(e.target.value);
      onBlur(e); // Pass to Formik's onBlur if necessary
    };
  
    return (
      <div className={layout === "inline" ? "d-flex align-items-center" : ""}>
        <label htmlFor={id} className="d-flex" style={{ width: layout === "inline" ? "20%" : "100%" }}>
          <span>
            {label}
            {required && <span className="text-danger ml-1">*</span>}
          </span>
          {showHelp && (
            <span id="helpTooltip" className="px-2">
              <i className="ri-question-line" style={{ cursor: "pointer", fontSize: "16px" }}></i>
            </span>
          )}
        </label>
        {showHelp && (
          <Tooltip
            placement="right"
            isOpen={tooltipOpen}
            target="helpTooltip"
            toggle={() => setTooltipOpen(!tooltipOpen)}
          >
            {helpText}
          </Tooltip>
        )}
        <div className="w-100">
          <Input
            type="text"
            name={name}
            id={id}
            placeholder={placeholder}
            value={value} // Use Formik’s value directly
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            invalid={errors.required || errors.range || errors.numeric}
            disabled={disabled}
          />
          {errors.required && <FormFeedback type="invalid">{errors.required}</FormFeedback>}
          {errors.range && <FormFeedback type="invalid">{errors.range}</FormFeedback>}
          {errors.numeric && <FormFeedback type="invalid">{errors.numeric}</FormFeedback>}
        </div>
      </div>
    );
  };
  
  export default AmountInput;
  